'use client';

import { useEffect } from 'react';
import { getDefaultCategories, useFeaturedBrand, useSearchPage } from '@libs/algolia';
import { PageType, usePageLayout } from '@libs/common-next';
import type { DigitalDataObject, DigitalDataProps } from './types';
import { getCustomerObject, getPageData, getProductObject } from '../../helpers/digitalData';

declare const window: Window &
    typeof globalThis & {
        digitalData: DigitalDataObject;
    };

export function DigitalData({ product, categories }: DigitalDataProps) {
    const { ocapi, pageType: appPageType, user, flags, userData } = usePageLayout();
    const isFeaturedBrand = useFeaturedBrand();
    const isSearchPage = useSearchPage();

    const searchPageType = isFeaturedBrand
        ? 'Brand Landing Page'
        : categories?.length && !isSearchPage
          ? 'Category Landing'
          : 'Product List';

    const currentPageType = appPageType === PageType.PLP ? searchPageType : 'Product Details';

    const customer = ocapi.data?.session.customer;

    useEffect(() => {
        const productCategories = product ? getDefaultCategories(product).map(cat => cat.name.default) : [];
        const productData = product ? getProductObject(product, productCategories) : {};

        const customerData = getCustomerObject(user, userData);

        const pageData = getPageData(categories ?? productCategories, currentPageType);

        window.digitalData = {
            ...window.digitalData,
            ...customerData,
            ...pageData,
            ...productData,
        };
    }, [customer, product, categories, currentPageType, user, userData, flags]);

    return '';
}
